import gql from "graphql-tag";

export const MY_LEAVE_REQUESTS_SUBSCRIPTION = gql`
  subscription leaveRequestsSubscription {
    leaveRequestsSubscription
  }
`;
